import { isAxiosError } from 'axios';
import axiosClient from './AxiosClient';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { HttpStatusCode } from 'axios';

interface AxiosInterceptorResponseProps {
  children: React.ReactNode;
}

const AxiosInterceptorResponse = ({ children }: AxiosInterceptorResponseProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axiosClient.interceptors.response.use(
      (response) => response,
      (error) => {
        if (isAxiosError(error)) {
          switch (error.response?.status) {
            case HttpStatusCode.BadRequest:
              break;
            case HttpStatusCode.NotFound:
              break;
            case HttpStatusCode.InternalServerError:
              navigate('/500');
              break;
            default:
              // APIをCallする前などresponseがないAxiosエラー
              navigate('/500');
              break;
          }
        } else {
          navigate('/500');
        }
      },
    );

    // クリーンアップ
    return () => {
      axiosClient.interceptors.response.eject(interceptor);
    };
  }, []);

  return <>{children}</>;
};

export default AxiosInterceptorResponse;
